import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dialog } from '@angular/cdk/dialog';

import { Observable } from 'rxjs';

import { AuthService } from '../auth/auth.service';

import { User } from '../interfaces/user';
import { DialogData } from '../interfaces/dialog-data';
import { UserAccountEditComponent } from '../user/user-account-edit/user-account-edit.component';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  authService = inject(AuthService);
  http = inject(HttpClient);
  private dialog = inject(Dialog);
  thisIsMe: boolean = false;

  constructor () { };

  getAllUsers (): Observable<User[]> {
    return this.http.get<User[]>('/api/user/all');
  };

  getSkyMarshals (): Observable<User[]> {
    return this.http.get<User[]>('/api/user/marshals');
  };

  createUser (first: string, last: string, email: string, password: string) {
    return this.http.post<User>('/api/user', {
      first: first,
      last: last,
      email: email,
      password: password
    });
  };

  updateUser (
    user_id: string, first: string, last: string, email: string, role: string, password: string = undefined, oldPassword: string = undefined
  ) {
    this.thisIsMe = (user_id == this.authService.getUser()._id);
    let updatedUser = {
      first: first,
      last: last,
      email: email,
      role: role
    };
    if (password) {
      updatedUser['password'] = password;
    }
    if (oldPassword) {
      updatedUser['oldPassword'] = oldPassword;
    }
    return this.http.put<User>('/api/user/id/' + user_id, updatedUser);
  };

  editUser (user: User, asAdmin: boolean = false, passbackUser: Function = undefined) {
    let userToEdit = Object.assign({}, user);
    const dialogRef = this.dialog.open<DialogData>(UserAccountEditComponent, {
      panelClass: 'edit-dialog',
      data: {
        documentName: "User",
        document: userToEdit,
        asAdmin: asAdmin,
      },
    });

    dialogRef.closed.subscribe(result => {
      if (result) {
        let updatedUser = result.document;
        let user_id: string = updatedUser['_id'];
        let first: string = updatedUser['first'];
        let last: string = updatedUser['last'];
        let email: string = updatedUser['email'];
        let role: string = updatedUser['role'];
        let oldPassword: string = undefined;
        let password: string = undefined;

        let hasProperty = updatedUser.hasOwnProperty('password');
        if (hasProperty) {
          password = updatedUser['password'];
        }

        let asAdmin = result['asAdmin'] || false;
        if (!asAdmin && password) {
          hasProperty = updatedUser.hasOwnProperty('oldPassword');
          if (hasProperty) {
            oldPassword = updatedUser['oldPassword'];
          }
        }

        this.updateUser(user_id, first, last, email, role, password, oldPassword).subscribe(
          (user: User) => {
            if (passbackUser) {
              passbackUser(user);
            }
            if (this.thisIsMe) {
              // authService.processUser will set the user and navigate to /user/assignments
              this.authService.processUser(user);
            }
          }
        );
      }
    });
  };

  changeUserPassword (userId: string, oldPassword: string, newPassword: string) {
    this.http.put('/api/user/' + userId + '/newPassword', {
      oldPassword: oldPassword,
      newPassword: newPassword
    }).subscribe(function (user: User) {
      console.log('resetUserPassword - user: ', user);
      return this.establishServerSession(user.email, newPassword);
    });
  };
};
